// @flow

import {
  HomeIcon,
  AnalyticsIcon,
  FilterMenuIcon,
  ThumbsUpIcon,
  SetupIcon,
  CartIcon,
  CartNotiIcon,
  IntegrationIcon,
  InsightIcon,
  SettingsIcon,
  ABTestingIcon,
  SettingsMinorIcon,
  PrimaryIcon,
  SearchIcon,
  AIIcon,
  ThemeIcon
} from 'src/components/containers/common/icon';
import { CustomersMinor } from '@shopify/polaris-icons';
import { routes } from 'src/routes';

export const EXTRA_ACTION = {
  CLEAR_CACHE_MANAGE_TEMPLATE: 'CLEAR_CACHE_MANAGE_TEMPLATE'
};

export const getMenuLeft = (i18n, conditions = {}) => {
  const {
    hideAISearch = false,
    usingNewTheme = false,
    hidePredictiveBundle,
    isHideBackInStockMenu,
    hasShopifyIntegration
  } = conditions;

  return [
    {
      title: i18n.translate('AdminHTML.MainMenuV2.home'),
      id: 'menu-home',
      icon: HomeIcon,
      routeTo: routes.dashboard.view(),
      isNew: false
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.filters'),
      id: 'menu-filters',
      icon: FilterMenuIcon,
      isNew: false,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.setup'),
          icon: SetupIcon,
          id: 'menu-filters-setup',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.filterTrees'),
              isNew: false,
              id: 'menu-filters-filter-trees',
              routeTo: routes.filterTree.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.merchandising'),
              isNew: false,
              id: 'menu-filters-merchandising',
              routeTo: `${routes.merchandising.view()}?panelID=collection`
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.filterLayout'),
              isNew: false,
              id: 'menu-filters-layout',
              isHide: !usingNewTheme,
              routeTo: routes.filterLayout.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.displaySettings'),
              isNew: false,
              id: 'menu-filters-display-settings',
              routeTo: routes.filterSettings.view()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.insights'),
          icon: InsightIcon,
          id: 'menu-filters-insights',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-collection',
              routeTo: routes.analytics.overviewCollection()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.tools'),
          icon: SettingsMinorIcon,
          id: 'menu-filters-tools',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.mergeValues'),
              isNew: false,
              id: 'menu-filters-merge-values',
              routeTo: routes.mergeValues.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.customRangeSliders'),
              isNew: false,
              id: 'menu-filters-custom-range-sliders',
              routeTo: routes.customRangeSlider.view()
            },
            ...(!hasShopifyIntegration ? [{
              title: i18n.translate('AdminHTML.MainMenuV2.swatches'),
              isNew: false,
              isHide: !usingNewTheme,
              id: 'menu-filters-swatch-settings',
              routeTo: routes.swatchSettings.view()
            }] : [])
          ]
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.search'),
      id: 'menu-search',
      icon: SearchIcon,
      isNew: false,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.setup'),
          icon: SetupIcon,
          id: 'menu-search-setup',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.searchControl'),
              isNew: false,
              id: 'menu-search-search-control',
              routeTo: routes.searchControl.view(),
              isHide: hideAISearch
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.standardSearch'),
              isNew: false,
              id: 'menu-search-standard-search',
              routeTo: routes.relevanceSettings.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.AIPowerSearch'),
              badge: 'ai',
              isNew: false,
              id: 'menu-search-ai-power-search',
              routeTo: routes.generalAdvancedSearch.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.merchandising'),
              isNew: false,
              id: 'menu-search-merchandising',
              routeTo: `${routes.merchandising.view()}?panelID=search`
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.insights'),
          icon: InsightIcon,
          id: 'menu-search-insights',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-search',
              routeTo: routes.analytics.overviewSearch()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.tools'),
          icon: SettingsMinorIcon,
          id: 'menu-search-tools',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.testYourSearch'),
              isNew: false,
              isHide: hideAISearch,
              id: 'menu-search-test-your-search',
              routeTo: routes.testYourSearch.view()
            }
          ]
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.recommendations'),
      id: 'menu-recommendation',
      isNew: false,
      icon: ThumbsUpIcon,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.setup'),
          icon: SetupIcon,
          id: 'menu-recommendation-setup',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.recommendationManageWidgets'),
              isNew: false,
              id: 'menu-recommendation-widget',
              routeTo: routes.recommendationWidgets.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.predictiveBundle'),
              isNew: true,
              id: 'menu-predictive-bundle',
              isHide: hidePredictiveBundle,
              routeTo: routes.predictiveBundle.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.recommendationGeneralSettings'),
              isNew: false,
              id: 'menu-recommendation-general-settings',
              routeTo: routes.recommendationGeneralSettings.settings()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.insights'),
          icon: InsightIcon,
          id: 'menu-recommendation-insights',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-recommendation',
              routeTo: routes.analytics.recommendationOverview()
            }
          ]
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.personalization'),
      id: 'menu-personalization',
      icon: CustomersMinor,
      routeTo: routes.personalization.view(),
      isNew: false
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.preOrder'),
      id: 'menu-pre-order',
      icon: CartIcon,
      isNew: true,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.preOrder'),
          icon: SetupIcon,
          id: 'menu-pre-order-common',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.preOrderCampaign'),
              isNew: false,
              id: 'menu-pre-order-campaign',
              routeTo: routes.preOrder.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-pre-order',
              routeTo: routes.analytics.preOrderProduct()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.backInStock'),
          icon: CartNotiIcon,
          id: 'menu-back-in-stock',
          isHide: isHideBackInStockMenu,
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.backInStockSettings'),
              isNew: false,
              id: 'menu-back-in-stock-settings',
              routeTo: routes.backInStock.settings()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.backInStockSubscription'),
              isNew: false,
              id: 'menu-back-in-stock-subscriptions',
              routeTo: routes.backInStock.subscription()
            }
          ]
        }
      ]
    }
  ];
};

export const getMenuRight = (i18n, conditions = {}) => {
  const {
    hasShopifyIntegration,
    enabledRecommendationType,
    enableAISearch,
    isAllowFeatureABTesting
  } = conditions;
  const result = [
    {
      title: '',
      id: 'menu-ai',
      icon: AIIcon,
      routeTo: routes.aiPowered.view()
    },
    {
      id: 'menu-ab-testing',
      icon: ABTestingIcon,
      routeTo: routes.abTesting.list(),
      isHide: !isAllowFeatureABTesting
    },
    {
      id: 'menu-analytics',
      icon: AnalyticsIcon,
      isNew: false,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.insights'),
          icon: InsightIcon,
          id: 'menu-performance-insights',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.revenueImpact'),
              isNew: false,
              id: 'menu-analytics-performance-revenue',
              routeTo: routes.analytics.appImpact()
            },
            {
              title: i18n.translate(
                `AdminHTML.MainMenuV2.${enableAISearch ? 'aiSearch' : 'search'}`
              ),
              isNew: false,
              id: 'menu-analytics-search',
              routeTo: routes.analytics.overviewSearch()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.filters'),
              isNew: false,
              id: 'menu-analytics-collection',
              routeTo: routes.analytics.overviewCollection()
            },
            {
              title: i18n.translate(
                `AdminHTML.MainMenuV2.${enabledRecommendationType ? 'aiRecommendation' : 'recommendation'
                }`
              ),
              isNew: false,
              id: 'menu-analytics-recommendation',
              routeTo: routes.analytics.recommendationOverview()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.preOrderAnalytics'),
              isNew: false,
              id: 'menu-analytics-pre-order',
              routeTo: routes.analytics.preOrderProduct()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.backInStockSubscription'),
              isNew: false,
              id: 'menu-back-in-stock-subscriptions',
              routeTo: routes.backInStock.subscription()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.tools'),
          icon: SettingsMinorIcon,
          id: 'menu-performance-tools',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analyticSettings'),
              isNew: false,
              id: 'menu-analytics-settings',
              routeTo: routes.analytics.settings()
            }
          ]
        }
      ]
    },
    {
      id: 'menu-integration',
      icon: PrimaryIcon,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.integration'),
          icon: IntegrationIcon,
          id: 'menu-integration-common',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.shopifyIntegration'),
              isNew: false,
              id: 'menu-integration-shopify-integration',
              routeTo: hasShopifyIntegration
                ? routes.shopifyIntegration.view()
                : routes.themeSetup.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.thirdPartyIntegration'),
              isNew: false,
              id: 'menu-integration-third-party',
              routeTo: routes.integration.view()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.layout'),
          icon: ThemeIcon,
          id: 'menu-integration-layout',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.templateLibrary'),
              isNew: false,
              id: 'menu-manage-shopify-integration',
              routeTo: routes.shopifyIntegration.templateLibrary(),
              extraAction: EXTRA_ACTION.CLEAR_CACHE_MANAGE_TEMPLATE
            }
          ]
        }
      ]
    },
    {
      id: 'menu-settings',
      icon: SettingsIcon,
      routeTo: routes.settings.view()
    }
  ];

  if (!hasShopifyIntegration) {
    const menuIntegrationIndex = result.findIndex(item => item.id === 'menu-integration');
    if (menuIntegrationIndex >= 0) {
      result[menuIntegrationIndex].children.splice(1, 1); // Remove template library when not turn of shopify integration (turbo version)
    }
  }
  return result;
};
